module.exports = __webpack_public_path__ + "static/kv-5c70be5c0b77599f326df7724f3fcdea.jpg";